import api from '../api';

export const deleteUserAvatarsService = async (
  userId: string,
): Promise<void> => {
  await api.delete(`/avatars/users/${userId}`);
};
